import { render } from "./Photos.page.vue?vue&type=template&id=46a56dd8&ts=true"
import script from "./Photos.page.vue?vue&type=script&lang=ts"
export * from "./Photos.page.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__